import moment from 'moment';

export const ABTestApp = {
    template: `
        <ab-test get-user="$ctrl.getUser()" authorization-key="{{$ctrl.getAuthorizationKey()}}">
            <ng-transclude></ng-transclude>
        </ab-test>
    `,
    transclude: true,
    controller: class {
        constructor($window, $timeout) {
            'ngInject';
            this.$window = $window;
            this.$timeout = $timeout;
            this.timeStart = moment();
            this.maxTimeout = 2000;
        }

        getAuthorizationKey() {
            return 'rmncrsqi8lev83rg8s8p1tgeur84jke1no6g';
        }

        async getUser() {
            const ga = await this.getGa();
            return ga.get('clientId');
        }

        getGa() {
            return new Promise((resolve, reject) => {
                const gaLoaded = () => {
                    if (moment().diff(this.timeStart) > this.maxTimeout) {
                        reject(new Error('Get GA Timeout'));
                    } else if (this.$window.ga) {
                        this.$timeout(reject, 500);
                        this.$window.ga(tracker => resolve(tracker));
                    } else {
                        this.$timeout(gaLoaded, 500);
                    }
                };
                gaLoaded();
            });
        }
    }
};
